import { render, staticRenderFns } from "./order-success.vue?vue&type=template&id=4e2c45e8&scoped=true"
import script from "./order-success.vue?vue&type=script&lang=js"
export * from "./order-success.vue?vue&type=script&lang=js"
import style0 from "./order-success.vue?vue&type=style&index=0&id=4e2c45e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2c45e8",
  null
  
)

export default component.exports